import { deviceModel } from './components/admin/CreateUpdateLabDevice'

export const wardType = {
  id: 'Id',
  ward: 'Ward Or Room',
  floor: 'Floor Number',
  location: 'Operating Unit',
  noWards: 'No  Wards Found',
  maximumBeds: 'Maximum Beds',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'actions',
}
export const bedType = {
  id: 'Id',
  bedName: 'Bed',
  floor: 'Floor Number',
  roomName: 'Room',
  location: 'Operating Unit',
  bedCategory: 'Bed Category',
  noBeds: 'No Beds Found',
  seqNo: 'Seq.No',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const roomType = {
  id: 'Id',
  wardName: 'Ward Name',
  floor: 'Floor Number',
  roomNUmber: 'Room Number',
  roomName: 'Room Name',
  location: 'Operating Unit',
  noRooms: 'No Rooms Found',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const AdminIntent = {
  DeletepanelById: 'deletePanelById',
  InactiveTests: 'InactiveTests',
  DeletePackageById: 'DeletePackage',
  InactivePackage: 'inactivePackage',
  DeleteDoctor: 'deleteDoctor',
  getSpecialty: 'getSpecilities',
  DeleteSpecialty: 'deleteSpecailty',
  DeleteBed: 'deleteBed',
  ArchiveBed: 'toggleBedActive',
  DeleteRoom: 'deleteRoom',
  ArciveRoom: 'toggleRoomActive',
  DeleteWard: 'deleteWard',
  ArchiveWard: 'toggleWardActive',
  DeleteSample: 'deleteSample',
  ArchiveSample: 'toggleSampleStatus',
  DeleteLabTest: 'deleteLabTest',
  ArchiveLabTest: 'toggleLabTestStatus',
  DeleteLabDepartment: 'deleteLabDepartment',
  ArchiveLabDepartment: 'toggleDepartmentStatus',
  DeleteUnitType: 'deleteUnitType',
  ArchiveUnitType: 'toggleTestUnitTypeStatus',
  DeleteResultType: 'deleteTestResultType',
  ArchiveResultType: 'toggleTestResultType',
  DeleteMethodType: 'deleteTestMethod',
  ArchiveMethodType: 'toggleTestMethodTypeStatus',
  DeleteTestRange: 'deleteTestResultLimit',
  ArchiveTestRange: 'toggleParameterRangeStatus',
  DeletePathologist: 'deletePathologist',
  getPanelById: 'getPanelById',
  getTestTemplateById: 'getTestTemplateById',
  getRadiologyTestTemplatesById: 'getRadiologyTestTemplatesById',
  updateTestTemplate: 'updateTestTemplate',
  createTestTemplate: 'createTestTemplate',
  createRadiologyTestTemplate: 'createRadiologyTestTemplate',
  updateRadiologyTestTemplate: 'updateRadiologyTestTemplate',
}
export const referredTo = 'Referred To'
export const validatedOn = 'Validated on'
export const Labintent = {
  getReferredLabResults: 'getReferredLabResults',
  getPatientsByIdsApi: 'getPatientsByIdsApi',
  getOrderEventsByOrder: 'getOrderEventsByOrder',
  getBacklogFromView: 'getBacklogFromView',
}

export const create = 'CREATE'
export const update = 'UPDATE'
export const opdTableHeadings = {
  sl: 'Sl No',
  UHID: 'UHID',
  RegType: 'Reg.Type',
  Name: 'Name',
  MobileNo: 'Mobile No',
  Gender: 'Gender',
  Age: 'Age',
  OperatingUnit: 'Operating Unit',
  CreatedOn: 'Created On',
  UpdatedOn: 'Updated On',
  PatientDoc: 'Patient Doc',
  View: 'View',
}

export const opdvisistIntent = {
  visitErrorMsg: 'Error fetching visits:',
}

export const departmentTableHeadings = {
  id: 'Id',
  department: 'Department Name',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const labTestTableHeadings = {
  id: 'Id',
  parameterName: 'Parameter Name',
  department: 'Department',
  sample: 'Sample',
  test: 'Test',
  resultType: 'Result Type',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
  parameter_short_form: 'Parameter Short Form',
}

export const methodTableHeadings = {
  id: 'Id',
  method: 'Method',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const resultTypeTableHeadings = {
  id: 'Id',
  resultType: 'Result Type',
  description: 'Description',
  options: 'Options',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const sampleTableHeadings = {
  id: 'Id',
  sampleName: 'Sample Name',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const testRangeTableHeadings = {
  id: 'Id',
  parameterName: 'Parameter Name',
  testName: 'Test Name',
  gender: 'Gender',
  method: 'Method',
  unitType: 'Unit Type',
  ageRange: 'Age Range',
  valueRange: 'Value Range',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const unitTypeTableHeadings = {
  id: 'Id',
  unit: 'Unit',
  description: 'Description',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
}

export const menuValues = {
  Doctor: 'doctor',
  Location: 'location',
  Bed: 'beds',
  Room: 'rooms',
  Ward: 'ward',
  LabDepartment: 'department',
  Method: 'method',
  Packages: 'packages',
  Parameter: 'labTest',
  ParameterRange: 'testRange',
  Pathologist: 'pathologist',
  ResultType: 'resultType',
  Sample: 'sample',
  Panel: 'panel',
  UnitType: 'unitType',
  Sequence: 'sequence',
  Partner: 'partner',
  parameterSequence: 'Parameter Sequence',
  reportTemplate: 'reportTemplate',
  radiologyReportTemplates: 'radiologyReportTemplates',
  none: 'none',
}
export const paragraphText = '<p><br></p>'
export const createLabOrderRoute = 'search/createorder/:id'
export const orderStatus = {
  ordered: 'ORDERED',
  orderedModified: 'ORDER_MODIFIED',
  collected: 'COLLECTED',
  collectionRejected: 'COLLECTION_REJECTED',
  rejected: 'REJECTED',
  collectionApproved: 'COLLECTION_APPROVED',
  entered: 'ENTERED',
  enteredReferred: 'ENTERED_REFERRED',
  submitted: 'SUBMITTED',
  approved: 'APPROVED',
  collection: 'collection',
  testing: 'testing',
  validation: 'validation',
  Dispatch: 'Dispatch',
}
export const labErrorMessages = {
  fecthPatient: 'unable to fetch patient',
  noPanels: 'No panels found for this order.',
  invoiceError: 'An error occurred while generating the invoice.',
}
export const allLabTab = {
  all: 'all',
  collection: 'collection',
  LOC_ALLOCATED: 'LOC_ALLOCATED',
  dispatch: 'dispatch',
  testing: 'testing',
  validation: 'validation',
  enter: 'enter',
  validate: 'validate',
}
export const patientConstants = {
  mobile: 'mobile',
  patientIdentifier: 'patient-identifier',
}
export const invoicePdf = {
  CBP: 'Complete Blood Picture (CBP) Blood',
}
export const SlotDetails = 'Slot Details'
export const TimeSlot = ' Time Slot : '
export const DateValue = 'Date :'
export const tagElements = {
  tag: 'tag',
  headingOne: 'h1',
  headingTwo: 'h2',
  paragraph: 'p',
  listItems: 'li',
  unlistItems: 'ul',
  strong: 'strong',
  em: 'em',
}
export const switchLoc = 'Switched to location'
export const labTabs = [
  'collection',
  'testing',
  'validation',
  'dispatch',
  'LOC_ALLOCATED',
  'all',
]
export const exceptDisptach = [
  'collection',
  'testing',
  'validation',
  'LOC_ALLOCATED',
]
export const BackLogButton = 'Backlog Orders'
export const validate = 'validate'
export const enter = 'enter'
export const Enter = 'Enter'
export const validateText = 'validate'
export const enterResults = 'Enter Results'
export const validationPending = 'Validation Pending'
export const viewResults = 'View results'
export const current = 'current'
export const backlog = 'backlog'
export const getLabResultByLabOrderIdIntent = 'getLabResultByLabOrderId'
export const systemResultEnteredBy = 'LIS'
export const LmsTestTab = 'testing'
export const enterMode = 'enter'
export const orderCollectedState = 'COLLECTED'
export const orderSubmittedState = 'SUBMITTED'
export const orderStatusRejected = 'REJECTED'
export const labDeviceTableColumns = [
  {
    name: 'name',
    label: 'Device Name',
    mandatory: true,
  },
  {
    name: 'facility',
    label: 'Operating Unit',
    dropDown: [],
    mandatory: true,
  },
  {
    name: 'location',
    label: 'Location',
    mandatory: false,
  },
  {
    name: 'model_id',
    label: 'Model',
    mandatory: true,
    dropDown: [],
  },
  {
    name: 'device_ip',
    label: 'Device IP',
    mandatory: false,
  },
  {
    name: 'internal_port',
    label: 'Internal Port',
    mandatory: false,
  },
  {
    name: 'external_port',
    label: 'External Port',
    mandatory: false,
  },
]

export const labDeviceModelColumns = [
  {
    name: 'name',
    label: 'Model Name',
    mandatory: true,
  },
  {
    name: 'equipment_name',
    label: 'Equipment Name',
    mandatory: true,
  },
  {
    name: 'department',
    label: 'Department',
    mandatory: false,
    dropDown: [],
  },
  {
    name: 'device_type',
    label: 'Device Type',
    dropDown: ['ANALYZER', 'VENTILATOR'],
    mandatory: true,
  },
  {
    name: 'default_connection_type',
    label: 'Mode',
    dropDown: ['listen', 'connect'],
    mandatory: true,
  },
  {
    name: 'protocol',
    label: 'Protocol',
    dropDown: ['HL7 MLLP', 'CIE', 'MEDIBUS', 'MEDIBUS.X', 'DAICOM'],
    mandatory: true,
  },
  {
    name: 'vendor',
    label: 'Vendor',
    mandatory: true,
  },
  {
    name: 'mapping_key',
    label: 'Mapping Key',
    mandatory: true,
    dropDown: ['CHANNEL_ID', 'TEST_CODE'],
  },
]

export const ParameterMappingsColumns = [
  {
    name: 'channel_id',
    label: 'Channel Id',
    mandatory: true,
  },
  {
    name: 'test_code',
    label: 'Device Parameter Code',
    mandatory: true,
  },
  {
    name: 'test_type',
    label: 'Test Type',
    mandatory: true,
  },
  {
    name: 'test_name',
    label: 'Device Parameter Name',
    mandatory: true,
  },
  {
    name: 'thop_name',
    label: 'Thop Parameter Name',
    mandatory: true,
    dropDown: [],
  },
  {
    name: 'thop_parameter_code',
    label: 'Thop Parameter Code',
    mandatory: true,
  },
  {
    name: 'result_type',
    label: 'Result Type',
    mandatory: true,
  },
  {
    name: 'decimal_precision',
    label: 'Decimal Precision',
    mandatory: true,
  },
  {
    name: 'scaling_factor',
    label: 'Scaling Factor',
    mandatory: true,
  },
]

export const lmsFormNoneMode = 'none'
export const lmsFormCreateMode = 'create'
export const lmsFormEditMode = 'edit'
export const labDeviceEnabledColumn = 'enabled'
export const labDeviceItem = 'labDevice'
export const labDeviceModelItem = 'labDeviceModel'
export const parameterMappingItem = 'parameterMapping'
export const labDeviceModelListenMode = 'listen'
export const labDeviceModelConnectMode = 'connect'
export const labdeviceModelColumn = 'model_id'
export const labDeviceOperatingUnitColumn = 'facility'
export const fillAllMandatoryFieldsWarning = 'Please fill all mandatory fields'
export const labDeviceModelDepartmentColumn = 'department'

export const connnectColumns = ['device_ip', 'external_port']
export const listenColumns = ['internal_port']
export const modelMandatoryColumns = [
  'name',
  'equipment_name',
  'device_type',
  'default_connection_type',
  'protocol',
  'vendor',
  'department',
  'mapping_key',
]
export const deviceMandatoryColumns = ['model_id', 'name', 'facility']
export const parameterMandatoryColumns = [
  'channel_id',
  'test_code',
  'test_type',
  'test_name',
  'thop_parameter_code',
  'thop_name',
  'result_type',
  'decimal_precision',
  'scaling_factor',
]
export const labDeviceRelatedItems = [
  'parameterMapping',
  'labDevice',
  'labDeviceModel',
]

export const FILE_UPLOAD_FAIL = 'Failed to upload file'
export const ID = 'id'
export const PARAMETER_DELETE_SUCCESS = 'Parameter deleted successfully'
export const EDIT = 'Edit'
export const ADD = 'Add'
export const NAVIGATE_PARAMETER_MAPPING = '/labDeviceModel/Parameters/'

export const getModel = (
  models: deviceModel[],
  values: Record<string, any>
) => {
  return models?.filter((model: any) => model?.name === values?.model_id)?.[0]
}

export const parameterMapping = 'Parameter Mapping'
export const labDeviceModels = 'Lab Device Models'
export const OF = 'of'
export const MODEL = 'Model'
export const printOptions = [
  { label: 'Medunited', value: 'medunited' },
  { label: 'Lab IQ', value: 'labIq' },
  { label: 'KIMS', value: 'kims' },
]
export const kimsString = 'kims'
export const labIqString = 'labIq'

export const collectOrderHeading = {
  SlNo: 'Sl No',
  LRNumber: 'LR.Number',
  UHID: 'UHID',
  Name: 'Name',
  MobileNo: 'Mobile No.',
  OP: 'Operating Unit',
  Service: 'Service',
  OrderedOn: 'Ordered On',
  Tests: 'Tests',
  Actions: 'Actions',
}
export const locErrorMsg = {
  AsignedLoc: 'Lab order updated successfully',
  FailedAsignedLoc: 'Failed to update lab order PU:',
}
export const DashboardTabs = {
  COLLECTED: 'COLLECTED',
}
export const LAB_ANALYZER_TABLE_HEADING = 'Lab Analyzers'
export const SUBMIT = 'Submit'
export const loadingMessage = 'Please Wait loading data...'
export const thopParameterNameField = 'thop_name'
export const thopParameterCodeField = 'thop_parameter_code'
export const resultTypeField = 'result_type'
export const parameterIdField = 'parameter_id'
export const labDeviceSearchItems = [
  'Device Name',
  'Model Name',
  'Vendor',
  'Operating Unit',
  'Location',
]

export const CREATE = 'Create'
export const testsLowercase = 'tests'
export const deviceNameField = 'Device Name'
export const deviceModelNameField = 'Model Name'
export const deviceVendorField = 'Vendor'
export const deviceOperatingUnitField = 'Operating Unit'
export const deviceLocationField = 'Location'
export const deviceNameKey = 'device_name'
export const deviceModelNameKey = 'model_name'
export const deviceVendorKey = 'vendor'
export const deviceOperatingUnitKey = 'facility'
export const deviceLocationKey = 'location'
export const printingMessage = 'Please Wait While Printing....'
export const WaitingMessage = 'Fetching report details...'
export const SampleCollection = 'SampleCollection'
export const SampleAcknowledge = 'SampleAcknowledge'
export const invoice = 'invoice'
export const saleOrder = 'sale_order'
export const successCancel = 'Successfully cancelled.'
export const cancelFailed = 'Cancellation failed.'
export const errorFailed = 'Something went wrong.'
export const reportGenerationFailed = 'Failed to generate report blob'
export const reportUpdateSuccessFull = 'Report Updated Successfully!'
export const reportUpdationError =
  'Something went wrong while uploading the report'
export const lmsIntent = {
  getDocIdForLabOrder: 'getDocIdForLabOrder',
  updateLabOrderWithDocId: 'updateLabOrderWithDocId',
  updateLabOrdersShort: 'updateLabOrdersShort',
}
export const NONE = 'NONE'
export const communicationYes = 'yes'
export const communicationNo = 'no'
export const notificationSent = 'Sent Notification successfully'
export const notificationFailure = 'send Notification Failed'
export const observationText = 'Observation'
export const uploadSuccess = 'Uploaded Successfully'
export const uploadFailure = 'Upload Failed'
export const collectionStates = [
  'ORDERED',
  'ORDER_MODIFIED',
  'COLLECTED',
  'REJECTED',
  'COLLECTION_REJECTED',
]
export const acknowledgeStates = ['LOC_ALLOCATED']
export const testingStates = [
  'ENTERED',
  'ENTERED_REFERRED',
  'COLLECTION_APPROVED',
]
export const validationStates = ['SUBMITTED']
export const dispatchStates = ['APPROVED']
export const laboratoryPhases = [
  'Collection',
  'Acknowledgement',
  'Testing',
  'Validation',
  'Dispatch',
]

export const COLLECTION = 'collection'
export const ACKNOWLEDGEMENT = 'LOC_ALLOCATED'
export const TESTING = 'testing'
export const VALIDATION = 'validation'
export const DISPATCH = 'dispatch'

export const COLLECTION_PHASE = 'COLLECTION'
export const ACKNOWLEDGEMENT_PHASE = 'ACKNOWLEDGEMENT'
export const TESTING_PHASE = 'TESTING'
export const VALIDATION_PHASE = 'VALIDATION'
export const DISPATCH_PHASE = 'DISPATCH'
export const APPROVED = 'APPROVED'
export const COMPLETED = 'COMPLETED'
export const refreshValue = 'refresh'
export const refreshKey = 'Refresh'
export const orderStatusValue = 'order-status'
export const orderStatusKey = 'Order Status'
export const currentKey = 'Current'
export const currentValue = 'current'
export const backlogKey = 'Backlog'
export const backlogValue = 'backlog'
export const registrationKey = 'registration'
export const selectTypeKey = 'Select Type'
export const selectTypeValue = 'selectValue'
export const archive = 'archive'
export const labSearchOptions = [
  { label: 'All', value: 'all' },
  { label: 'Archive', value: 'archive' },
]
export const selectCSV = 'Please select a CSV file.'
export const emptyErrorMsg = 'Uploaded CSV is empty!'
export const invalidMsg = 'Invalid data found in'
export const invalidMsgTwo =
  ' row(s). Please fill all fields and remove invalid columns.'
export const validMsg =
  'Data validated successfully. Please click Process to upload.'
export const errorReadMsg = 'Failed to read the file.'
export const errorvalidatefirst = 'Please validate the file first!'
export const errorEndPoint = 'No upload API found for'
export const erroruploadfailed = 'Error uploading data.'
export const UploadCSV = 'Upload a CSV or Excel file with bulk'
export const BUTTON_TEXT = {
  PROCESSING: 'Processing...',
  PROCESS: 'Process',
}
export const UPLOAD_TEMPLATES: Record<
  string,
  { headers: string[]; filename: string }
> = {
  beds: {
    headers: [
      'bed_number',
      'bed_description',
      'bed_category_id',
      'room_id',
      'location_id',
      'created_by',
      'updated_by',
    ],
    filename: 'bed_upload_template.csv',
  },
  panel: {
    headers: [
      'name',
      'test_short_form',
      'description',
      'sample_id',
      'department_id',
      'handled_at',
      'tat',
      'price',
      'odoo_test_id',
      'updated_by',
      'created_by',
    ],
    filename: 'lab_test_template.csv',
  },
  labtest: {
    headers: [
      'name',
      'description',
      'parameter_short_form',
      'panel_id',
      'result_type_id',
      'created_by',
      'department_id',
      'updated_by',
    ],
    filename: 'parameter_upload_template.csv',
  },
  testrange: {
    headers: ['lab_test_id', 'sample_id', 'parameter_id'],
    filename: 'parameter_range_upload_template.csv',
  },
  packages: {
    headers: [
      'name',
      'price',
      'active_from',
      'active_till',
      'created_by',
      'updated_by',
      'package_id',
    ],
    filename: 'packages_upload_template.csv',
  },
}
export const noTemplate = 'No download template available for this section.'
export const download = 'download'
export const upload = 'upload'
export const UPLOAD_ITEM_TYPES = [
  'beds',
  'panel',
  'labtest',
  'testrange',
  'packages',
]
export const DownlaodTemplate = 'Download Template'
export const BulkCreation = 'Bulk Creation'
export const UPLOAD_ACTION_OPTIONS = [
  { value: '', label: 'Action' },
  { value: 'download', label: 'Download Template' },
  { value: 'upload', label: 'Bulk Creation' },
]
export const sequence = 'sequence'
export const exceedingResultsConstants = {
  view: 'view',
  approve: 'approve',
  enter: 'enter',
  submit: 'submit',
  validatorComments: 'Enter validator Comments',
  userComments: 'Enter user comments',
  NocommentsProvided: 'No comments provided',
  submitResults: 'Exceeding Submit Results',
  approveResults: 'Exceeding Approved Results',
  Submit: 'Submit',
  Approve: 'Approve',
}
export const exceedingResultsForLabTests = 'exceedingResultsForLabTests'
export const submitLabOrderJourney = 'submitLabOrderJourney'
export const approvedResultsJourney = 'approvedResultsJourney'
export const regular = 'regular'
export const viewConsentedResults = 'View Consented Results'
export const noConsentedResults = 'No Consented Results'
export const noLrGeneration = 'Lr Number Not Generated'
export const YES = 'yes'
export const NO = 'no'
export const SMS = 'SMS'
export const WHATSAPP = 'WHATSAPP'
export const INITIAL_PAGE = 0
export const INITIAL_PAGE_SIZE = 100
export const INITIAL_TOTAL_COUNT = 0

export const LMS_ERROR_MESSAGES = {
  FETCH_PATIENTS: 'Error fetching patient details',
  FETCH_ORDERS: 'Error fetching lab orders',
  FETCH_DEPARTMENTS: 'Error fetching lab departments',
  INVOICE_GENERATION: 'Error generating invoice',
  NO_PANELS: 'No panels available for this order',
}

export const orderEventStatus = {
  ORDERED: 'Ordered',
  SAMPLE_COLLECTED: 'Sample Collected',
  TEST_LOCATION_ALLOCATED: 'Test Location allocated',
  SAMPLE_COLLECTION_COMPLETED: 'Sample Collection Completed',
  SAMPLES_APPROVED: 'Samples Approved',
  SAMPLES_REJECTED: 'Samples Rejected',
  RESULTS_ENTERED: 'Results Entered',
  REFERRED_RESULTS_ENTERED: 'Referred Results Entered',
  RESULTS_SUBMITTED: 'Results Submitted',
  RESULTS_APPROVED: 'Results Approved',
  RESULTS_REJECTED: 'Results Rejected',
}

export const REJECTED_TEST = 'rejected-test'
export const NO_VALID_RANGE = 'No Valid Range'
export const NUMERIC = 'Numeric'
export const OUT_SIDE_NORMAL_RANGE = 'Outside Normal Range'
export const ABNORMAL = 'abnormal'
export const NUMERIC_OUTCOME = 'Numeric Outcome'
export const SHORT_TEXT = 'Short Text'
export const HIDE_NOTES = 'Hide Notes'
export const SHOW_NOTES = 'Show Notes'
export const reportstages = {
  fetching: 'fetching',
  generating: 'generating',
}
export const COLLECTED_TABLE_CONSTANTS = {
  // Messages
  MESSAGES: {
    PDF_DOWNLOADED: 'PDF downloaded successfully',
    PDF_PROCESSING_ERROR: 'Failed to process PDF for download',
    PDF_DOWNLOAD_ERROR: 'Failed to download PDF',
    POPUP_BLOCKED: 'Pop-up blocked. PDF downloaded instead.',
    DOWNLOADING: 'PDF downloaded',
  },

  // User agent detection regex
  MOBILE_TABLET_REGEX:
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,

  // Browser detection
  BROWSER: {
    FIREFOX: 'firefox',
    EDGE: 'edg',
    SAFARI: 'safari',
    CHROME: 'chrome',
    IE_TRIDENT: 'trident',
    IE_MSIE: 'msie',
  },

  // Browser-specific positions
  DOWNLOAD_BUTTON_POSITIONS: {
    RIGHT: {
      FIREFOX: '219px',
      EDGE: '190px',
      SAFARI: '120px',
      CHROME: '162px',
      IE: '150px',
      DEFAULT: '200px',
    },
    TOP: {
      FIREFOX: '2px',
      EDGE: '4px',
      SAFARI: '12px',
      CHROME: '11px',
      IE: '10px',
      DEFAULT: '10px',
    },
  },

  // Timeouts
  TIMEOUTS: {
    LINK_CLEANUP: 500,
    DOWNLOAD_CLEANUP: 1000,
  },

  // Styles
  DOWNLOAD_BUTTON_STYLES: {
    POSITION: 'fixed',
    Z_INDEX: '1000',
    PADDING: '8px 16px',
    CURSOR: 'pointer',
    BG_COLOR: 'blue',
    TEXT_COLOR: 'white',
    BORDER: 'none',
    BORDER_RADIUS: '4px',
    FONT_SIZE: '14px',
    FONT_WEIGHT: '500',
    FONT_FAMILY: 'Arial, sans-serif',
    BOX_SHADOW: '0 2px 4px rgba(0,0,0,0.2)',
    OUTLINE: 'none',
  },

  // Element styles
  LINK_STYLES: {
    POSITION: 'fixed',
    LEFT: '-9999px',
  },

  IFRAME_STYLES: {
    WIDTH: '100%',
    HEIGHT: '100%',
    BORDER: 'none',
  },

  // File naming
  FILE_NAME_SEPARATOR: '_',
  FILE_EXTENSION: '.pdf',
  DEFAULT_FILE_PREFIX: 'Lab_Report',
} as const

export const labIq = 'lab-iq'
/** Identifier used for Lab IQ client-specific LMS behavior toggles. */
export const locationType = 'Location Type'
